import { useUserStore } from '@/store/user'
import { createRouter, type RouteRecordRaw, createWebHistory } from 'vue-router'
import { featureRoutes } from '../app/features'

const routes: RouteRecordRaw[] = [...featureRoutes]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async to => {
  const store = useUserStore()
  const isAuthenticated = await store.isAuthenticated
  if (to.meta.auth && !isAuthenticated) return '/login'
  if (!store.hasPermission(to.meta.permission as string)) return '/home'
})

export default router
